"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NextPage = require("./NextPage/NextPage");
var _Numbers = require("./Numbers/Numbers");
var _PreviousPage = require("./PreviousPage/PreviousPage");
require("./Pagination.scss");
const Pagination = _ref => {
  let {
    onClick,
    className,
    total = 1,
    current = 1,
    surrounding = 2,
    arePrevAndNextShown = true,
    text = {
      previousPage: 'previous page',
      nextPage: 'next page'
    }
  } = _ref;
  const currentPage = !current || current < 1 ? 1 : current > total ? total : current;
  if (total <= 1) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-Pagination', className)
  }, arePrevAndNextShown && /*#__PURE__*/_react.default.createElement(_PreviousPage.PreviousPage, {
    current: currentPage,
    onClick: onClick,
    text: text
  }), /*#__PURE__*/_react.default.createElement(_Numbers.Numbers, {
    total: total,
    current: currentPage,
    surrounding: surrounding,
    onClick: onClick
  }), arePrevAndNextShown && /*#__PURE__*/_react.default.createElement(_NextPage.NextPage, {
    total: total,
    current: currentPage,
    onClick: onClick,
    text: text
  }));
};
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map